import React from 'react'

const PricingPage = () => {
  return (
    <main className="min-h-screen bg-slate-50">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <header className="mb-10 sm:mb-14">
          <p className="text-sm font-semibold text-emerald-600 mb-2 uppercase tracking-wide">
            Pricing
          </p>
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-light text-slate-900 mb-4 leading-tight">
            Simple, transparent pricing for events and offers
          </h1>
          <p className="text-base sm:text-lg text-slate-600 leading-relaxed max-w-3xl font-light">
            Obule is designed to be flexible for both small and large organizers. This page gives a
            high‑level overview of how fees work. Actual pricing and payout schedules may vary by
            country, payment method, and specific agreements with centers and organizers.
          </p>
        </header>

        <div className="space-y-10">
          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-3">Platform fees</h2>
            <p className="text-base text-slate-600 leading-relaxed font-light">
              We typically charge a small service fee per ticket or offer sold, plus payment
              processing charges from our payment provider. Organizers can choose to absorb these
              fees or pass some or all of them on to attendees. In many cases, our fees are
              competitive with or lower than traditional ticketing providers while offering richer
              analytics and tools.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-3">Organizer payouts</h2>
            <p className="text-base text-slate-600 leading-relaxed font-light">
              Payouts to centers and organizers are based on the net amount after applicable fees
              and refunds. Depending on your location and risk profile, payouts may be scheduled on
              a regular cadence (for example, weekly or after an event ends) and transferred to
              your nominated bank account or wallet.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-3">Custom pricing</h2>
            <p className="text-base text-slate-600 leading-relaxed font-light">
              If you run large or recurring events, or if you process a high volume of offers,
              please reach out to our team. We can work with you to design a pricing arrangement
              that matches your scale and needs, including possible discounts, custom onboarding,
              and dedicated support.
            </p>
          </section>
        </div>
      </div>
    </main>
  )
}

export default PricingPage

